<template>
  <v-app-bar title="PolicyFly Internal" color="darknavyblue">
    <template #prepend>
      <v-app-bar-nav-icon @click="toggleNavbar" />
    </template>

    <v-spacer />

    <template v-if="loggedIn">
      <DomainSelect class="mr-2" />
      <EnvironmentSelect />

      <v-tooltip location="bottom" text="Logout">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            size="x-small"
            icon="mdi-logout"
            variant="flat"
            color="background"
            class="mx-4"
            @click="handleLogout"
          />
        </template>
      </v-tooltip>
    </template>

    <ThemeSwitcher size="x-small" class="mr-6" />
  </v-app-bar>
</template>

<script lang="ts">
import { ThemeSwitcher } from '@policyfly/components'
import { computed, defineComponent, useModel } from 'vue'
import { useRouter } from 'vue-router'

import DomainSelect from '@/components/DomainSelect.vue'
import EnvironmentSelect from '@/components/EnvironmentSelect.vue'
import { useApiStore } from '@/stores/api'

import { RouteNames } from '@/router'

export default defineComponent({
  name: 'AppBar',

  components: {
    DomainSelect,
    EnvironmentSelect,
    ThemeSwitcher,
  },

  emits: {
    // eslint-disable-next-line vue/no-unused-emit-declarations
    'update:modelValue': (_value: boolean) => true,
  },

  props: {
    modelValue: { type: Boolean, required: true },
  },

  setup (props) {
    const apiStore = useApiStore()
    const loggedIn = computed(() => {
      return apiStore.loggedIn
    })
    const router = useRouter()
    async function handleLogout (): Promise<void> {
      apiStore.logout()
      await router.push({ name: RouteNames.LOGIN })
    }

    const model = useModel(props, 'modelValue')
    function toggleNavbar (): void {
      model.value = !model.value
    }

    return {
      loggedIn,
      handleLogout,
      toggleNavbar,
    }
  },
})
</script>
